const constants = {
  YANDEX_API_KEY: '6b1daf10-1199-48e9-8a41-f19078683987',
  DEFAULT_CENTER: [55.751244, 37.618423],
  INITIAL_ZOOM: 13,
  BOUNDS_DELTA: 0.005, // ~550 метров
  // API_ADRESS: 'http://localhost:3008/api'
  API_ADRESS: 'https://api.blablabam.syndevo.ru/api'
};

export default constants